


















































































import { Component, Watch } from "vue-property-decorator";
import { PanduanStoreModule } from "@/store/modules/PanduanStore";
import Vue from "vue";
import { appModule } from "@/store/modules/app";

@Component
export default class PanduanDrawer extends Vue {
  public showSearch = false;
  public searchStr = "";

  get panduanDrawer() {
    return appModule.panduanDrawer;
  }
  set panduanDrawer(val: boolean) {
    appModule.setPanduanDrawer(val);
  }

  get listPanduan() {
    return PanduanStoreModule.listPanduan;
  }

  get filteredPanduanList() {
    if (!this.searchStr) {
      return this.listPanduan;
    }
    const searchLower = this.searchStr.toLowerCase();

    return this.listPanduan.filter(p => {
      return p.judul && p.judul.toLowerCase().includes(searchLower);
    });
  }

  toggleSearch(): void {
    if (this.showSearch) {
      this.searchStr = "";
      //PanduanStoreModule.fetchPanduan();
    }
    this.showSearch = !this.showSearch;
  }

  // async getDataPanduan(): Promise<void> {
  //   await PanduanStoreModule.fetchPanduan(this.searchStr);
  // }

  async fetchFullPanduan(): Promise<void> {
    await PanduanStoreModule.fetchPanduan();
  }

  @Watch("panduanDrawer")
  onPanduanDrawerChanged(val: boolean) {
    if (val) this.fetchFullPanduan();
    else {
      this.searchStr = "";
      this.showSearch = false;
    }
  }

  getFileName(path: string): string {
    if (!path) return "";
    return path.split("/").pop() || path;
  }

  hide() {
    this.panduanDrawer = false;
  }

  bukaDokumen(p: any) {
    // 1. Jika panduan berupa Link URL
    if (p.link) {
      window.open(p.link, "_blank", "noopener,noreferrer");
      return;
    }

    // 2. Jika panduan berupa File
    if (p.url || p.file) {
      const targetUrl = p.url || p.file;
      const fileName = p.file || p.url || "";
      const isPdf = fileName.toLowerCase().endsWith(".pdf");

      if (isPdf) {
        const newTab = window.open(targetUrl, "_blank");

        if (!newTab) {
          appModule.sendErrorAlert(
            "Izinkan pop-up di browser untuk membuka file."
          );
        } else {
          newTab.opener = null;
        }
      } else {
        // Paksa download untuk file selain PDF (doc, docx, dll)
        const link = document.createElement("a");
        link.href = targetUrl;
        link.download = this.getFileName(fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
}
